module.exports = __webpack_public_path__ + "img/upload-icon-active.af9ce9c1.svg";